<template>
    <div class="navigation-container">
        <img src="../assets/logo-circle-color.png" class="nav-logo" @click ="isCollapsed = !isCollapsed" :var="isCollapsed">
        <h5 class="menu-text" @click ="isCollapsed = !isCollapsed" :var="isCollapsed">menu</h5>
            <Transition>
            <ul v-if="isCollapsed" class="nav">
                <a href="#home"><li><h3 class="nav-item">Home</h3></li></a>
                <a href="#discography">
                    <li>
                    <h3 class="nav-item">Discography</h3>
                </li>
                </a>
                <a href="#upcoming-shows"><li><h3 class="nav-item">Upcoming Shows</h3></li></a>
                <a href="#tour-2025"><li><h3 class="nav-item">Tour 2025</h3></li></a>
                <a href="mailto:kirstyn.blandy@gmail.com"><li><h3 class="nav-item">Contact</h3></li></a>
                <!-- social medias -->
                <div class="social-media-bar">
                    <a href="https://isolationtankensemble1.bandcamp.com/album/heliography" target="blank"><img src="../assets/icon-bandcamp2.png" class="nav-item nav-icon"></a>
                    <a href="mailto:kirstyn.blandy@gmail.com"><img src="../assets/icon-contact.png" class="nav-item nav-icon"></a>
                    <a href="https://soundcloud.com/isolationtankensemble" target="blank"><img src="../assets/icon-soundcloud.png" class="nav-item nav-icon"></a>
                    <a href="https://www.instagram.com/isolationtankensemble/?hl=en" target="blank"><img src="../assets/icon-instagram.png" class="nav-item nav-icon"></a>
                    <a href="https://www.facebook.com/isolationtankensemble/" target="blank"><div class="fb-step-off nav-item nav-icon">f</div></a>
                    <a href="https://linktr.ee/isolationtankensemble" target="blank"><img src="../assets/lintree-logo.png" class="nav-item nav-icon"></a>
                </div>
            </ul>
            </Transition>
        <!-- </div> -->
    </div>
        <div>
            <div class="header">
                <img alt="Iso logo" src="../assets/logo.png" class="logo">
            </div>
            <div class="header-text">
                <p>
                    We are a <b>cinematic</b>, <b>instrumental</b>,  <b>progressive</b> 6 piece hailing from <b>Louisville, Kentucky</b>.
                </p>
            </div>
            <div class="band-photos">
                <!-- <div class="image-wrapper"> -->
                <img src="../assets/kirstyn.jpeg" class="band-member" alt="Kirstyn the violinist smiling broadly and having a blast.">
                <!-- </div> -->
                <img src="../assets/mateo.jpeg" class="band-member" alt="Mateo on electric mandolin, grinning.">
                <img src="../assets/andrew.jpeg" class="band-member" alt="Andrew plalys Electric guitar, with a very serious expression.">
                <img src="../assets/lamar.jpeg" class="band-member" alt="Lamar on drums is focused with a drumstick blurred from dynamic movement.">
                <img src="../assets/richard.jpeg" class="band-member" alt="Richard is on bass, feeling the groove focusing hard.">
                <img src="../assets/matt.jpeg" class="band-member" alt="Matt is in another dimension in front of his electric keys.">
            </div>
            </div>

</template>

<script>
export default {
  name: 'HeaderView',
  data() {
    return {
      isCollapsed: false,
    }
    // showMenu() {
    //     if (!isCollapsed) {
    //         document.getElementsByClassName("nav").classList.remove("hidden")
    //     }
    //     else {
    //         document.getElementsByClassName("nav").classList.add("hidden");
    //     }
    // }

}
}




</script>

<style>

/* Transitions */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
/* /Transitions */

.background-image {
    background-size: 100%;
    background-repeat: no-repeat;
    margin: 2em;
}

.band-member {
    object-fit: cover;
    width: 6em;
    height: 16em;
    margin: 1px;
}

.band-photos {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    width: 90vw;
    margin: auto;
}

.fb-step-off {
    width: 2em;
    text-align: center;
    font-weight: bolder;
    color: black;
    padding-top: -4px;
    border: 1px solid black;
}

.flex-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    
}

.header {
  display: flex;
  flex-direction: row;
}

.header-text {
    margin-top: -2em;
    text-align: center;
}
.menu-text {
    margin-top: -.5em;
    padding-right: .7em;
}

.nav {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-top: -1em;
    margin-right: -10px;
    padding-right: 24px;
    border-radius: 16px 0 0 16px;
    background: linear-gradient(290deg, #fbd485ae, #f09f8c, #ed3d85, #681012);
    border: 2px solid transparent;

    /* background-image: linear-gradient(290deg, #fbd485, #f09f8c, #ed3d85, #681012); */
}
.nav-item {
    height: auto;
    font-size: 1em;
}
.nav-item:hover {
    background-color:#f09f8c;
}

.nav-icon {
    height: 2em;
    font-size: 1em;
    border: 2px solid #681012;
    background: linear-gradient(290deg, #fbd485ae, #f09f8c, #ed3d85, #681012);
    border-radius:10px;
}

.nav-icon:hover {
    background:#f09f8c;
}
.navigation-container {
    text-align: right;
    padding: 1em;
    top: 0;
    right: 0;
    position: fixed;
    border-radius: 7px;
}
.nav-logo {
    width: 3em;
    background-color: #fff3e4;
    border-radius: 50%;
}

.hidden {
    display: none;
}

.social-media-bar {
    display: flex;
    flex-direction: row;
    justify-content: center;
}
/* .image-wrapper {
    height: 3rem;
    width: 2rem;
} */

/* media queries */
@media only screen and (min-width: 500px) {
    .band-member {
        width: 8em;
        height: 20em;
        margin: 2px;
    }
}

@media only screen and (min-width: 600px) {
    .header-text {
        font-size: 1.5em;
    }

}

@media only screen and (min-width: 1000px) {
    .band-member {
        width: 10em;
        height: 26em;
        margin: 4px;
        
    }
    .header-text {
        font-size: 1.5em;
    }

    p {
        font-size: 1.2em;
    }
}

</style>